import * as React from 'react'
import { connect, FormikProps, getIn } from 'formik'

import { metaProp } from '@espoon-voltti/ts-libs/lib/validation'

import { Section } from '@espoon-voltti/react-components/layout'

import {
  Column,
  Columns,
  Title
} from '@espoon-voltti/react-components/elements'
import {
  SelectOptionProps,
  SumField
} from '@espoon-voltti/react-components/elements/form'
import {
  fieldState,
  ErrorMessage
} from '@espoon-voltti/react-voltti/components/form/formik-util'

import {
  FormIntegerField,
  FormSelectField
} from '@espoon-voltti/react-voltti/components/form'

import {
  Activity,
  Members,
  TargetGroup
} from '@espoon-voltti/nuora-domain/applicants'

import { ProjectGrantDraftApp } from '../../../domain'
import { t } from '../../../i18n'

export const NuoraOrgInfo = () => (
  <Section dataQa={'nuoraOrgInfo'}>
    <Title size={3}>{t(['org', 'additionalInfo', 'title'])}</Title>
    <Columns>
      <Column size={8}>
        <Columns>
          <Column>
            <FormSelectField
              label={t(['org', 'additionalInfo', 'activity', 'label'])}
              name={'applicant.nuoraOrg.activity'}
              dataQa={'activity'}
              placeholder={t(['org', 'additionalInfo', 'activity', 'label'])}
              options={activityOptions()}
            />
          </Column>
          <Column>
            <FormSelectField
              label={t(['org', 'additionalInfo', 'targetGroup', 'label'])}
              name={'applicant.nuoraOrg.targetGroup'}
              dataQa={'targetGroup'}
              placeholder={t(['org', 'additionalInfo', 'targetGroup', 'label'])}
              options={targetGroupOptions()}
            />
          </Column>
        </Columns>
      </Column>
    </Columns>

    <Title size={3}>
      {t(['org', 'additionalInfo', 'members', 'info', 'label'])}
    </Title>
    <Columns>
      <Column size="one-fifth">
        <FormIntegerField
          name="applicant.nuoraOrg.members.from7to20"
          dataQa="membersFrom7to20"
          label={t(['org', 'additionalInfo', 'members', 'from7to20', 'label'])}
        />
      </Column>
      <Column size="one-fifth">
        <FormIntegerField
          name="applicant.nuoraOrg.members.from21to28"
          dataQa="membersFrom21to28"
          label={t(['org', 'additionalInfo', 'members', 'from21to28', 'label'])}
        />
      </Column>
      <Column size="one-fifth">
        <FormIntegerField
          name="applicant.nuoraOrg.members.from29"
          dataQa="membersFrom29"
          label={t(['org', 'additionalInfo', 'members', 'from29', 'label'])}
        />
      </Column>

      <Column size="one-fifth" align="end">
        <MembersTotal />
      </Column>
    </Columns>
  </Section>
)

const MembersTotal = connect<{}, ProjectGrantDraftApp>(
  ({ formik }: { formik: FormikProps<ProjectGrantDraftApp> }) => {
    const fieldName = 'applicant.nuoraOrg.members'
    const totalFieldName = metaProp(fieldName)
    const touched = !!Object.keys(
      formik.values.applicant.nuoraOrg.members
    ).find((x) => !!getIn(formik.touched, `${fieldName}.${x}`))
    const state = fieldState(totalFieldName, formik, touched)

    return (
      <SumField
        dataQa="membersTotal"
        message={<ErrorMessage name={totalFieldName} touched={touched} />}
        state={state}
      >
        <span data-qa="label">
          {t(['org', 'additionalInfo', 'members', 'total', 'label'])}:{' '}
        </span>
        <span data-qa="sum">
          {total(formik.values.applicant.nuoraOrg.members)}
        </span>
      </SumField>
    )
  }
)

const targetGroups: TargetGroup[] = ['ALL', 'BOYS', 'GIRLS']
const activities: Activity[] = [
  'EARLY_YOUTH_ACTIVITIES',
  'HOBBY_CLUBS',
  'OTHER',
  'POLITICAL',
  'SCOUT',
  'SPIRITUAL'
]

const targetGroupOptions = (): SelectOptionProps[] =>
  targetGroups.map((x) => ({
    id: x,
    dataQa: x,
    label: t(['org', 'additionalInfo', 'targetGroup', 'values', x])
  }))

const activityOptions = (): SelectOptionProps[] =>
  activities.map((x) => ({
    id: x,
    dataQa: x,
    label: t(['org', 'additionalInfo', 'activity', 'values', x])
  }))

const total = (x: Members) => x.from7to20 + x.from21to28 + x.from29
